<template>
    <div class="register">
        <div class="inner">
            <div>
                <el-form ref="formR" :model="formR" :rules="rules">
                    <el-col :span="24">
                        <div class="text-center account-login-title">注册</div>
                        <hr class="line" />
                    </el-col>
                  <el-form-item prop="idCard">
                    <el-input
                      placeholder="身份证号码"
                      v-model="formR.idCard"
                      class="first-input my-input"
                    ></el-input>
                  </el-form-item>
                   <el-form-item prop="email">
                    <el-input
                        placeholder="邮箱号"
                        v-model="formR.email"
                        class="first-input my-input"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                       <el-input
                           placeholder="手机号"
                           v-model="formR.phone"
                           class="first-input my-input"
                       ></el-input>
                   </el-form-item>
                   <el-form-item prop="temp">
                       <el-input placeholder="手机验证码" v-model="formR.temp" class="yzm">
                           <el-button
                               slot="append"
                               :disabled="disabledyzm"
                               @click="getYZMZC()"
                           >{{btntxt}}</el-button>
                       </el-input>
                   </el-form-item>
                   <el-form-item prop="password">
                       <el-input
                           placeholder="密码"
                           v-model="formR.password"
                           class="second-input my-input"
                           type="password"
                       ></el-input>
                   </el-form-item>
                   <el-form-item prop="spassword">
                       <el-input
                           placeholder="确认密码"
                           v-model="formR.spassword"
                           class="second-input my-input"
                           type="password"
                           @keyup.enter.native="submitFuncR('formR')"
                       ></el-input>
                 </el-form-item>
                 <el-form-item>
                        <el-checkbox class="login-form__tos" v-model="checked"></el-checkbox>
                        <span class="tip">
                            已阅读并同意
                            <a href="#" @click="getUser()">《用户服务协议》</a>和
                            <a href="#" @click="getYiSi()">《隐私策略》</a>
                        </span>
                    </el-form-item>
                    <el-form-item>
                        <el-row>
                            <el-col :span="24">
                                <button
                                    class="btn-center login-button"
                                    type="button"
                                    @click="submitFuncR('formR')"
                                >确认</button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-row>
            <el-col>
                <el-dialog
                    :title="title"
                    :visible.sync="centerDialogVisible"
                    width="60%"
                    center
                    class="mianUser"
                >
                    <span>{{content}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="centerDialogVisible = false">同 意</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import rules from "@/common/rules";
export default {
    name: "register",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.formR.spassword !== "") {
                    // this.$refs.user.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else
              if (value !== this.formR.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };

        return {
            rules: {
                idCard: [
                  {
                    required: false,
                    pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                    message: "请输入正确的身份证号码",
                  }
                ],
                email: [
                    {
                        required: false,
                        type: "email",
                        message: "请输入正确的邮箱号",
                        trigger: "blur"
                    }
                ],
                temp: [
                    {
                        required: false,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                // password: [
                //     { validator: validatePass, trigger: "blur" },
                //     {
                //         min: 6,
                //         max: 20,
                //         message: "长度在 6 到 20 个字符",
                //         trigger: "blur"
                //     }
                // ],
                // spassword: [
                //     { validator: validatePass2, trigger: "blur" },
                //     {
                //         min: 6,
                //         max: 20,
                //         message: "长度在 6 到 20 个字符",
                //         trigger: "blur"
                //     }
                // ],
                phone: [
                    {
                        required: false,
                        message: "请输入正确的手机号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validatePhone,
                        trigger: ["blur", "change"]
                    }
                ]
            },
            activeName: "first",
            formR: {
                email: "",
                temp: "",
                phone: "",
                password: "",
                spassword: ""
            },
            checked: true,
            centerDialogVisible: false,
            title: "",
            content: "",
            btntxt: "获取验证码",
            disabledyzm: false,
            time: 60
        };
    },
    methods: {
        // 注册手机验证码获取
        getYZMZC() {
            let that = this;
            if (!that.formR.phone) {
                that.$message.error("请先输入手机号");
                return false;
            }
            let url = "/user/phone/sendCodeToPhone";
                    let params = {
                        phone: that.formR.phone,
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                that.disabledyzm = true;
                                that.timeryzm();
                                that.$message({
                                    message: "验证码发送成功",
                                    type: "success"
                                });
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            
                        });
        },
        // 注册
        submitFuncR(formR) {
            let that = this;
            that.$refs[formR].validate(valid => {
                if (valid) {
                    if (!this.checked) {
                        that.$message({
                            type: "warning",
                            message: "请阅读《用户服务协议》和《隐私策略》"
                        });
                        return false;
                    }
                    let url = "/user/registPhoneOrIdCardOrEmail";
                    let params = {
                        email: that.formR.email,
                        phone: that.formR.phone,
                        temp: that.formR.temp,
                        password: that.formR.password,
                        username: that.formR.username,
                        idCard: that.formR.idCard
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                that.$message({
                                    message: "注册成功",
                                    type: "success"
                                });
                                // that.$router.replace({
                                //     path: "/login"
                                // });
                                let arr = res.data.data;
                                sessionStorage.clear();
                                sessionStorage.setItem("token", arr.token);
                                sessionStorage.setItem("YS", false);
                                sessionStorage.setItem(
                                    "userInfo",
                                    JSON.stringify(arr)
                                );
                                if (localStorage.getItem("loginBeforeUrl")) {
                                    window.location.href = localStorage.getItem(
                                        "loginBeforeUrl"
                                    );
                                    localStorage.removeItem("loginBeforeUrl");
                                } else {
                                    that.$router.replace({
                                        path: "/index"
                                    });
                                }
                                // 刷新兄弟组件
                                let NewPage =
                                    "_empty" +
                                    "?time=" +
                                    new Date().getTime() / 500;
                                this.$router.push(NewPage);
                                this.$router.go(-1);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            // that.$message.error("网络错误！");
                        });
                }
            });
        }
    }
};
</script>

<style scoped>
.set-margin {
    margin-top: 20px;
}
.two {
    font-size: 14px;
    padding-bottom: 20px;
    cursor: pointer;
}
.login {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
}

.outer {
    padding: 50px 0px;
    height: 415px;
    /* background: url(../assets/logo/outer.png) no-repeat center center; */
    position: relative;
    margin: 0 auto;
}
.inner {
    padding: 20px 40px;
    width: 400px;
    margin: 0 auto;
    background-color: #fff;
}
.inner1 {
    top: 65px;
}
.login-button {
    width: 100%;
    height: 46px;
    background-color: #f64320;
    border-radius: 2px;
    color: #fff;
    border: 1px solid #f64320;
}
.login-button:focus {
    border: 1px solid #f64320 !important;
}
.weixin {
    display: inline-block;
    vertical-align: middle;
}
.refresh-icon {
    background-color: #fff !important;
}
.register {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
    padding: 30px 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/register.vue